<template>
  <v-sheet>
    <v-navigation-drawer
      app
      left
      clipped
      :permanent="drawerShow"
      enable-resize-watcher
      v-model="drawer"
      class="elevation-1"
      width="11em"
      :mini-variant="drawerMini"
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="group"
        >
          <template v-for="module in modules">
            <v-list-item v-if="canRead(module.module)" :key="module.code"
                         :value="module.code">
              <v-list-item-icon>
                <v-icon>{{ module.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ module.text }}</v-list-item-title>
            </v-list-item>
          </template>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      height="54px"
      color="grey lighten-4"
      elevation="1"
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" :disabled="drawerShow" />
      <v-menu z-index="4000" open-on-hover>
        <template v-slot:activator="{ on: menu, attrs }">
          <v-btn
            fab
            x-small
            color="orange"
            elevation="2"
            v-bind="attrs"
            v-on="{ ...menu }"
          >
            <span style="font-weight: bold; font-size: 20px; color: white; -webkit-text-stroke: 1px #ffc979; ">S</span>
          </v-btn>
        </template>
        <v-card>
          <MainMenu />
        </v-card>
      </v-menu>

      <v-toolbar-title>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              {{ getTitle() }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ getSubtitle() }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar-title>

      <v-spacer />

      <!-- tlačítkové ovládání -->
      <template v-if="this.$store.state.data.def !== null">

        <v-menu v-if="tableVisible && $store.state.data.def.periodView !== undefined && $store.state.data.def.periodView"
                ref="monthMenu"
                v-model="monthMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                nudge-left="100"
                max-width="290px"
                min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              style="font-weight: bold; margin-top: 4px; margin-right: 5px;"
              color="transparent"
              v-bind="attrs"
              v-on="on"
            >{{ formatMonth($store.state.data.month) }}
            </v-chip>
          </template>
          <v-date-picker
            v-model="$store.state.data.month"
            @input="monthMenu = false"
            type="month"
            :max="getCurrenDateInMS()"
            no-title
            scrollable
            :locale="getIsoLocale()"
          >
          </v-date-picker>
        </v-menu>

        <template v-if="tableVisible">
          <v-text-field
            :label="$t('common.fast_filter')"
            prepend-icon="mdi-filter"
            clearable
            v-model="filter"
            hide-details
            dense
            flat
            solo
            background-color="transparent"
            class="pl-1 pr-4 hidden-sm-and-down transparent-background"
            style="max-width: 180px"
          >
          </v-text-field>

          <template v-if="canWrite() && this.$store.state.data.def.editable">
            <v-tooltip bottom open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="hidden-sm-and-down" icon @click="newRecord" v-on="on" v-bind="attrs">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("data.toolbar.new_record") }}</span>
            </v-tooltip>
          </template>
        </template>

        <span v-else>
        <template v-if="canWrite()">
          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="hidden-sm-and-down" icon @click="sendEventClick('store')" v-on="on" v-bind="attrs">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("data.toolbar.record_store") }}</span>
          </v-tooltip>
        </template>

        <v-tooltip bottom open-delay="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="hidden-sm-and-down" icon @click="sendEventClick('cancel')" v-on="on" v-bind="attrs">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </template>
          <span>{{ (canWrite()) ? $t("data.toolbar.record_cancel") : $t("data.toolbar.view_cancel")
            }}</span>
        </v-tooltip>

        <v-menu offset-y v-if="this.recordMenuItems.length > 0">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom open-delay="500">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  class="hidden-sm-and-down"
                  icon
                  v-bind="attrs"
                  v-on="{ ...tooltip, ...menu }"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("data.toolbar.actions") }}</span>
            </v-tooltip>
          </template>
          <v-list>
              <template v-for="(item, index) in this.recordMenuItems">
                <v-list-item v-if="item.permission()"
                             :key="index"
                             link
                             @click="sendEventClick(item.action)"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </template>
          </v-list>
        </v-menu>

      </span>

        <v-divider class="hidden-md-and-down" vertical inset />
        <span class="text-h6 font-weight-bold pl-2 sokol-color hidden-md-and-down">Sokol</span>

        <!-- menu ovládání -->

        <v-menu offset-y>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom open-delay="500">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  class="hidden-md-and-up"
                  icon
                  v-bind="attrs"
                  v-on="{ ...tooltip, ...menu }"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("data.toolbar.actions") }}</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item v-if="canWrite() && tableVisible" link @click="newRecord">
              <v-list-item-title>{{ $t("data.toolbar.new_record") }}</v-list-item-title>
            </v-list-item>

            <v-list-item v-if="canWrite() && !tableVisible" link
                         @click="sendEventClick('store')">
              <v-list-item-title>{{ $t("data.toolbar.record_store") }}</v-list-item-title>
            </v-list-item>

            <v-list-item v-if="!tableVisible" link @click="sendEventClick('cancel')">
              <v-list-item-title>
                {{ (canWrite()) ? $t("data.toolbar.record_cancel") : $t("data.toolbar.view_cancel")
                }}
              </v-list-item-title>
            </v-list-item>

            <template v-if="!tableVisible">
              <template v-for="(item, index) in this.recordMenuItems.length > 0">
                <v-list-item v-if="item.permission()"
                             :key="index"
                             link
                             @click="sendEventClick(item.action)"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </template>
            </template>
          </v-list>
        </v-menu>
      </template>

    </v-app-bar>

    <router-view />

    <ConfirmDialog ref="confirm" />
  </v-sheet>
</template>

<script>
import ConfirmDialog from "@/components/dialogs/ConfirmDialog";
import MainMenu from "@/components/MainMenu";
import defs from "@/modules";
import i18n from "@/plugins/i18n";
import { DateTime } from "luxon";

export default {
  name: "DataView",

  components: {
    ConfirmDialog,
    MainMenu
  },

  data() {
    return {
      drawer: true,
      group: 0,
      filter: null,
      monthMenu: false,

      modules: [
        { code: "vehicles", icon: "mdi-car", text: this.$t("data.item.vehicles"), module: "vehicle" },
        { code: "persons", icon: "person", text: this.$t("data.item.persons"), module: "person" },
        {
          code: "groupsets",
          icon: "workspaces",
          text: this.$t("data.item.groupsets"),
          module: "groupset"
        },
        {
          code: "contracts",
          icon: "widgets",
          text: this.$t("data.item.contracts"),
          module: "contract"
        },
        {
          code: "subjects",
          icon: "store",
          text: this.$t("data.item.subjects"),
          module: "subject"
        },
        {
          code: "sharings",
          icon: "share_location",
          text: this.$t("data.item.sharings"),
          module: "sharing"
        },
        {
          code: "special-accesses",
          icon: "manage_accounts",
          text: this.$t("data.item.special-accesses"),
          module: "special-access"
        },
        {
          code: "companies",
          icon: "mdi-domain",
          text: this.$t("data.item.companies"),
          module: "company"
        },
        {
          code: "device-connections",
          icon: "mdi-car-connected",
          text: this.$t("data.item.deviceConnections"),
          module: "device-connection"
        },
        {
          code: "api-connections",
          icon: "mdi-account-network",
          text: this.$t("data.item.apiConnections"),
          module: "api-connection"
        }
      ],

      recordMenu: [
        { name: "delete", title: "Vymazat záznam", action: "delete", permission: this.canDeleteRecord }
      ]
    };
  },

  methods: {
    newRecord() {
      this.$router.push({ name: "data/" + this.$store.state.data.module, params: { id: "new" } });
    },

    getTitle() {
      if (this.$store.state.data.record === null) {
        if (this.$store.state.data.module != null && defs[this.$store.state.data.module].getTableName != null)
          return defs[this.$store.state.data.module].getTableName();
        else
          return "-";
      } else {
        if (this.$store.state.data.module != null && defs[this.$store.state.data.module].getItemName != null) {
          return defs[this.$store.state.data.module].getItemName(this.$store.state.data.record, true) || "nový záznam";
        } else
          return "-";
      }
    },

    getSubtitle() {
      if (this.$store.state.data.module != null && defs[this.$store.state.data.module].showCompany)
        return this.$store.state.auth.company.name;
      else
        return null;
    },

    async sendEventClick(action) {
      if (action !== "delete" || await this.$refs.confirm.open(
        this.$t("view.delete_msg"),
        null,
        {
          buttons: [
            { name: "cancel", text: this.$t("dialog.confirm.button_cancel"), result: false, color: "primary" },
            { name: "delete", text: this.$t("dialog.confirm.button_delete"), result: true, color: "error" }
          ]
        })) {
        this.$store.dispatch("data/pushEvent", { target: "view", click: action });
      }
    },

    canDeleteRecord() {
      return this.canDelete();
    },

    getIsoLocale() {
      return i18n.messages[i18n.locale].lang.iso;
    },

    getCurrenDateInMS() {
      return DateTime.now().startOf("day").plus({ "days": 1 }).toISO();
    },

    formatMonth(date) {
      if (date !== null)
        return DateTime.fromFormat(date, "yyyy-M").toLocaleString({ month: "long", year: "numeric" });
      else
        return "";
    }
  },

  watch: {
    filter: function() {
      this.$store.dispatch("data/setFastFilter", this.filter);
    },

    group: function() {
      switch (this.group) {
        case "vehicles":
          if (this.$route.name !== "data/vehicles")
            this.$router.push({ name: "data/vehicles" });
          return;
        case "persons":
          if (this.$route.name !== "data/persons")
            this.$router.push({ name: "data/persons" });
          return;
        case "groupsets":
          if (this.$route.name !== "data/groupsets")
            this.$router.push({ name: "data/groupsets" });
          return;
        case "contracts":
          if (this.$route.name !== "data/contracts")
            this.$router.push({ name: "data/contracts" });
          return;
        case "subjects":
          if (this.$route.name !== "data/subjects")
            this.$router.push({ name: "data/subjects" });
          return;
        case "sharings":
          if (this.$route.name !== "data/sharings")
            this.$router.push({ name: "data/sharings" });
          return;
        case "special-accesses":
          if (this.$route.name !== "data/special-accesses")
            this.$router.push({ name: "data/special-accesses" });
          return;
        case "companies":
          if (this.$route.name !== "data/companies")
            this.$router.push({ name: "data/companies" });
          return;
        case "device-connections":
          if (this.$route.name !== "data/device-connections")
            this.$router.push({ name: "data/device-connections" });
          return;
        case "api-connections":
          if (this.$route.name !== "data/api-connections")
            this.$router.push({ name: "data/api-connections" });
          return;
      }
    },

    "$store.state.data.record": function() {
      if (this.$store.state.data.record !== null)
        this.group = null;
    },

    "$store.state.data.activeEvent": function() {
      if (this.$store.state.data.activeEvent != null && this.$store.state.data.activeEvent.target === "container") {

        this.$store.dispatch("data/processEvents");
      }
    },

    "$store.state.data.month": function() {
      const def = defs[this.$store.state.data.module];
      if (def.periodView !== null && def.periodView)
        this.$store.dispatch("data/fetchRecords", { module: this.$store.state.data.module });
    }

  },

  computed: {
    drawerMini() {
      return true; //this.$vuetify.breakpoint.lgOnly || this.$vuetify.breakpoint.mdOnly
    },

    drawerShow() {
      return this.$vuetify.breakpoint.mdAndUp; //&& this.drawer
    },

    tableVisible() {
      return this.$store.state.data.record === null;
    },

    recordMenuItems() {
      return this.recordMenu.filter(x => x.permission());
    }
  },

  mounted() {
    if (this.$route.query["month"] !== undefined && this.$route.query["month"] !== null)
      this.$store.state.data.month = this.$route.query["month"];
  }
};
</script>

<style lang="sass" scoped>
.sokol-color
  color: #c06432

.transparent-background > .v-input__slot
  background-color: transparent !important

</style>